import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellSimple, Check } from "@phosphor-icons/react";
import { notificationService } from "../services/notificationService";

function timeAgo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "justo ahora";
  if (mins < 60) return `hace ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `hace ${hours} h`;
  const days = Math.floor(hours / 24);
  return `hace ${days} d`;
}

export default function NotificationsPage() {
  const [items, setItems] = useState([]);

  async function load() {
    setItems(await notificationService.list());
  }

  useEffect(() => {
    load();
  }, []);

  async function markAll() {
    await notificationService.markAllRead();
    load();
  }

  return (
    <div className="px-5 pt-6 pb-10" data-testid="notifications-page">
      <div className="mx-auto max-w-3xl">
        <header className="mb-6 flex items-end justify-between">
          <div>
            <p className="zx-label">Susurros</p>
            <h1 className="font-serif text-3xl tracking-tight md:text-4xl">
              Avisos
            </h1>
          </div>
          <button
            onClick={markAll}
            className="flex items-center gap-2 rounded-full border border-[rgba(255,255,255,0.12)] px-3 py-2 text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.65)] hover:border-[rgba(255,255,255,0.3)]"
            data-testid="notifications-mark-all-read"
          >
            <Check size={12} weight="thin" /> Marcar leídos
          </button>
        </header>

        <div className="space-y-3 zx-stagger">
          {items.length === 0 && (
            <div className="zx-card flex flex-col items-center gap-2 p-8 text-center">
              <BellSimple size={22} weight="thin" className="text-[rgba(255,255,255,0.5)]" />
              <p className="text-sm text-[rgba(255,255,255,0.65)]">Sin avisos por ahora.</p>
            </div>
          )}
          {items.map((n) => (
            <NotifItem key={n.id} item={n} onRead={() => notificationService.markRead(n.id).then(load)} />
          ))}
        </div>
      </div>
    </div>
  );
}

function NotifItem({ item, onRead }) {
  const Content = (
    <div
      className={[
        "zx-card block p-4 text-left transition-all",
        item.read ? "opacity-60" : "",
      ].join(" ")}
      data-testid={`notif-${item.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-xl tracking-tight text-[#f5f5f5]">
            {item.title}
          </h3>
          <p className="mt-1 text-sm text-[rgba(255,255,255,0.7)]">{item.body}</p>
        </div>
        {!item.read && (
          <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-[#B8325A] shadow-[0_0_10px_#B8325A]" />
        )}
      </div>
      <p className="mt-3 text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.4)]">
        {timeAgo(item.createdAt)}
      </p>
    </div>
  );

  if (item.link) {
    return (
      <Link to={item.link} onClick={onRead} className="block">
        {Content}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onRead} className="block w-full">
      {Content}
    </button>
  );
}
